var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImageCountObjects = function SvgImageCountObjects(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "currentColor",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6485 5.65437C12.6482 5.65408 12.6479 5.65378 12.6476 5.65348L7.34466 0.350708C7.11863 0.124573 6.81811 0 6.49844 0C6.17878 0 5.87826 0.124474 5.65212 0.350609L0.351927 5.6507C0.350142 5.65249 0.348356 5.65437 0.346571 5.65616C-0.117601 6.12301 -0.116808 6.88046 0.348852 7.34612C0.561598 7.55897 0.842581 7.68225 1.143 7.69514C1.1552 7.69633 1.1675 7.69693 1.1799 7.69693H1.39126V11.5994C1.39126 12.3717 2.01958 13 2.79201 13H4.8667C5.07696 13 5.24756 12.8295 5.24756 12.6191V9.55957C5.24756 9.20718 5.53419 8.92054 5.88659 8.92054H7.1103C7.46269 8.92054 7.74933 9.20718 7.74933 9.55957V12.6191C7.74933 12.8295 7.91982 13 8.13019 13H10.2049C10.9773 13 11.6056 12.3717 11.6056 11.5994V7.69693H11.8016C12.1212 7.69693 12.4217 7.57246 12.6479 7.34632C13.1141 6.87987 13.1143 6.12112 12.6485 5.65437Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageCountObjects, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image-count-objects.7d00d5ec.svg";
export { ForwardRef as ReactComponent };